import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { Box, Stack, Text, Button } from '@ltvco/refresh-lib/theme';
import {
  FeatureBlockedModal,
  useFeatureBlockedModal,
} from '@ltvco/refresh-lib/v2';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface CourtSearchCTAProps {
  personName: string;
}

export function CourtSearchCTA({ personName }: CourtSearchCTAProps) {
  const navigate = useNavigate();
  const { isBlocked } = useSubscriptionAccessConfigContext();
  const {
    openFeatureBlockedModal,
    isFeatureBlockedModalOpen,
    closeFeatureBlockedModal,
  } = useFeatureBlockedModal();

  const [searchType, setSearchType] = useState<string>('');
  const [paymentShowModalNumber, setPaymentShowModalNumber] =
    useState<number>(0);

  const handleSearchClick = () => {
    if (isBlocked('court_cases')) {
      setSearchType('Court Cases');
      openFeatureBlockedModal();
      return;
    }

    navigate(
      `/dashboard/court-cases/cases?query=${encodeURIComponent(
        `${personName}`
      )}&exact_match=true`
    );
  };

  return (
    <>
      <Box
        sx={{
          mb: 3,
          p: 3,
          borderRadius: 2,
          border: (theme) => `1px solid ${theme.palette.divider}`,
          backgroundColor: (theme) => theme.palette.background.paper,
        }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={{ xs: 'center', md: 'space-between' }}
          alignItems={{ xs: 'center', md: 'center' }}
          spacing={{ xs: 2, md: 0 }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Text variant="h4" mb={1}>
              Search for Court Cases containing any "{personName}"
            </Text>
            <Text variant="body1" color="text.secondary" mb={0}>
              Find federal court cases, legal opinions, and case details
            </Text>
          </Box>
          <Button
            variant="contained"
            onClick={handleSearchClick}
            sx={{
              borderRadius: '32px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
              minWidth: { xs: '200px', md: 'auto' },
            }}
          >
            Search Court Cases
          </Button>
        </Stack>
      </Box>

      <FeatureBlockedModal
        isOpen={isFeatureBlockedModalOpen}
        onClose={closeFeatureBlockedModal}
        searchType={searchType}
        paymentShowModalNumber={paymentShowModalNumber}
        setPaymentShowModalNumber={setPaymentShowModalNumber}
      />
    </>
  );
}
